(function () {
    'use strict';
    var m = angular.module('app');
    m.factory('dualAppHelper', ["http", "feature", "dualAppModal", "modulesManager", "$q", "path", "modals", "brandInfo", "autologinHelper", "$cookies", "$rootScope", "loadingModal", function (http, feature, dualAppModal, modulesManager, $q, path, modals, brandInfo, autologinHelper, $cookies, $rootScope, loadingModal) {
        var office365Modules = [
            'office365_emails',
            'office365_onedrive',
            'office365_sharepoint'
        ];
        // we perform only first step of dual-auth for gsuite
        var gsuiteModules = [];
        var dualAppHelper = {
            authenticationStatus: function (authName, moduleName, authMode) {
                return http.get('/api/v1/' + authName + '/authentication').params({
                    moduleName: moduleName,
                    mode: authMode ? authMode : 'normal'
                });
            },
            getAuthObject: function (authName, moduleName, authMode) {
                return http.get('/api/v1/' + authName + '/authentication/object').params({
                    moduleName: moduleName,
                    mode: authMode ? authMode : 'normal'
                });
            },
            checkDualApp: function (moduleName) {
                if (feature.enableSingleAuth) {
                    office365Modules = [];
                }
                var checkModules = -1, authName = null;
                checkModules = _(office365Modules).findIndex(function (module) {
                    return module === moduleName;
                });
                if (checkModules !== -1) {
                    authName = 'office365';
                } else {
                    checkModules = _(gsuiteModules).findIndex(function (module) {
                        return module === moduleName;
                    });
                    if (checkModules !== -1) {
                        authName = 'gsuite';
                    }
                }
                return {
                    isDualApp: checkModules !== -1,
                    authName: authName
                };
            },
            checkActiveStatusO365: function () {
                return modulesManager.init().then(function () {
                    var activeApps = modulesManager.activeSaasApps();
                    var count = 0;
                    activeApps.forEach(function (app) {
                        if (app.name === 'office365_emails' || app.name === 'office365_onedrive' || app.name === 'office365_sharepoint') {
                            count++;
                        }
                    });
                    if (count > 0) {
                        return $q.when({ data: 'normal' });
                    }
                    return $q.when({ data: 'initial' });
                });
            },
            dualAppWizard: function (UIoptions) {
                if (dualAppHelper.checkDualApp(UIoptions.moduleName).authName === 'gsuite') {
                    return dualAppHelper.getAuthObject('gsuite', UIoptions.moduleName).then(function (response) {
                        window.localStorage.setItem('dualAuthStarted', JSON.stringify({
                            path: window.location.href,
                            saas: UIoptions.moduleName,
                            mode: 'normal'
                        }));
                        if (autologinHelper.enabled() || $cookies.get('autologinCP')) {
                            $rootScope.$broadcast('dual-auth-started-1');
                            window.open(response.data.steps[1].auth_link, '_blank').focus();
                        } else {
                            window.location.href = response.data.steps[1].auth_link;
                        }
                    });
                }
                // dual-auth for office365
                return dualAppModal.show({ moduleInfo: UIoptions });
            },
            o365ResetReauth: function () {
                return http.get('/api/v1/office365/reauth_reset');
            },
            o365EmailsMFAModal: function (saveConfigFn, prevModal) {
                var modalParams = [
                    {
                        sentence: brandInfo.getBrandLabel() + ' requires PowerShell access in order to automatically configure the needed mail' + ' flow settings in your Exchange admin center. Please choose whether your admin has turned on multi-factor' + ' authentication (MFA) in your organization for administrator users.In case MFA is not enabled, a service user ' + 'will be created as an admin and used for setting the initial configuration. The user will be disabled once the' + ' configuration is done.',
                        class: 'about-app-creation'
                    },
                    {
                        id: 'use_mfa',
                        type: 'radio-group',
                        buttons: [
                            {
                                label: 'Not using multi-factor authentication',
                                value: 'no'
                            },
                            {
                                label: 'Using multi-factor authentication',
                                value: 'yes'
                            }
                        ],
                        paramClass: 'full-width-param o365-config-mode'
                    },
                    {
                        id: 'username',
                        type: 'string',
                        label: 'Admin email address',
                        enabled: [{
                                param: 'use_mfa',
                                equal: 'yes'
                            }],
                        validation: { required: { message: 'Email address can not be empty' } },
                        labelClass: 'o365-mfa-username-label',
                        paramClass: 'o365-mfa-username-param'
                    },
                    {
                        id: 'password',
                        type: 'password',
                        label: 'App password',
                        enabled: [{
                                param: 'use_mfa',
                                equal: 'yes'
                            }],
                        validation: { required: { message: 'Password can not be empty' } },
                        labelClass: 'o365-mfa-password-label',
                        paramClass: 'o365-mfa-password-param',
                        showPassword: true
                    },
                    {
                        sentence: '#' + JSON.stringify({
                            text: 'If MFA is required, please input the username of a global admin in your ' + 'organization and an app password for this user.<br>For help generating an app password, ' + '<a href="https://support.office.com/en-us/article/create-an-app-password-for-office-365-3e7c860f-bda4-4441-a618-b53953ee1183" ' + 'target="_blank">click here</a>.',
                            display: 'html'
                        }),
                        class: 'about-app-creation',
                        enabled: [{
                                param: 'use_mfa',
                                equal: 'yes'
                            }]
                    }
                ];
                var modalTitle = 'Office 365 Onboarding';
                return modals.params([{
                        lastPage: true,
                        hideDefaultButton: true,
                        defaultBtnLabel: 'Dismiss',
                        params: modalParams
                    }], modalTitle, 'md', {
                    backdrop: 'static',
                    keyboard: false,
                    hideCloseBtn: true,
                    windowClass: 'o365-mfa-modal-container'
                }).then(function (data) {
                    if (data.use_mfa === 'yes') {
                        return loadingModal.show({
                            title: 'Office 365 Onboarding status',
                            comment: '<div class="loading-comment">Verifying user details<div class="fa fa-spinner fa-pulse fa-2x green-check"></div></div>',
                            backdrop: 'static',
                            hideDefaultBtn: true,
                            defaultBtnLabel: 'Dismiss',
                            hideLoading: true,
                            type: 'o365Onboarding',
                            api: function () {
                                var postData = {
                                    username: data.username,
                                    password: data.password,
                                    save_mfa_info: true
                                };
                                return http.post('/api/v1/o365emails_verify_password').body(postData).run();
                            },
                            buttons: [{
                                    label: 'Ok',
                                    class: 'btn-success',
                                    action: function ($modalInstance) {
                                        return dualAppHelper.o365EmailsMFAModal(saveConfigFn, $modalInstance);
                                    }
                                }]
                        }).then(function () {
                            if (_(prevModal).isObject() && _(prevModal.dismiss).isFunction()) {
                                prevModal.dismiss();
                            }
                            return $q.when();
                        }, function () {
                            if (_(prevModal).isObject() && _(prevModal.dismiss).isFunction()) {
                                prevModal.dismiss();
                            }
                            return $q.when();
                        });
                    } else {
                        return dualAppHelper.o365OnboardingAlertModal().then(function () {
                            if (_(prevModal).isObject() && _(prevModal.dismiss).isFunction()) {
                                prevModal.dismiss();
                            }
                            // set username and password and flag in auth config
                            saveConfigFn('office365_auth', { has_mfa: false });
                        });
                    }
                }, function () {
                    if (_(prevModal).isObject() && _(prevModal.dismiss).isFunction()) {
                        prevModal.dismiss();
                    }
                    return $q.when();
                });
            },
            o365OnboardingAlertModal: function () {
                return modals.params([{
                        lastPage: true,
                        hideDefaultButton: true,
                        params: [{
                                sentence: '#' + JSON.stringify({
                                    text: 'Office 365 Onboarding is in progress, Onboarding status can be viewed from either ' + 'SAAS health status or system tasks menu',
                                    display: 'text'
                                }),
                                class: 'about-app-creation'
                            }]
                    }], 'Office 365 Onboarding', 'md', {
                    backdrop: 'static',
                    keyboard: false,
                    hideCloseBtn: true,
                    windowClass: 'o365-mfa-modal-container'
                });
            },
            showGSuiteAuthSuccessModal: function () {
                var pdfLink = path('common').staticFile('CP-Gmail-GCDS-Setup.pdf');
                var moreInfo = '';
                if (!feature.checkpointTheme) {
                    pdfLink.path = 'https://www.avanan.com/manuals/gmail-integration-gcds';
                }
                if (!feature.lastlineTheme && !feature.sonicwallTheme) {
                    moreInfo = '<div>For more info <a href="' + pdfLink.path + '" target="_blank">click here</a></div>';
                }
                return modals.alert('<div class="gsuite-auth-success-modal">' + '<div>As part of the application approval, 2 new groups were created in your GSuite environment:</div>' + '<ul>' + '<li>' + brandInfo.getBrand() + '_monitor_policy@' + brandInfo.customerSubdomain() + '</li>' + '<li>' + brandInfo.getBrand() + '_inline_policy@' + brandInfo.customerSubdomain() + '</li>' + '</ul>' + '<div>If you are using GCDS to sync your groups with an LDAP, you would need to exclude the groups from the sync. See "' + '<strong>Exclusion Rules for your Google domain data</strong>" in ' + '<a href="https://support.google.com/a/answer/6138405?hl=en" target="_blank">' + 'https://support.google.com/a/answer/6138405?hl=en</a> and contact support if you need our help.</div>' + moreInfo + '</div>', {
                    display: 'html',
                    title: 'Authorized G Suite successfully'
                });
            },
            checkGSuiteAuthSuccess: function (forceReload) {
                modulesManager.init(forceReload).then(function () {
                    var activeApps = modulesManager.activeSaasApps();
                    if (activeApps && activeApps.length && _(activeApps).findIndex(function (activeApp) {
                            return activeApp.name === 'google_drive';
                        }) !== -1) {
                        dualAppHelper.showGSuiteAuthSuccessModal();
                    } else {
                        dualAppHelper.checkGSuiteAuthSuccess(true);
                    }
                });
            },
            o365AlertTextModal: function () {
                return modals.alert('Redirecting to Microsoft portal in order to authorize the apps', {
                    display: 'text',
                    title: '',
                    autoClose: true,
                    autoCloseTime: 2000,
                    disableCloseBtn: true
                });
            }
        };
        return dualAppHelper;
    }]);
}());